import { useSelector } from 'react-redux'
import { RootState } from '../../store/configure-store'
import { httpService } from '../../services/http-service'
import { SelectCompanyPrompt } from '../../cmps/general/select-company-prompt'
import EmployeeTable from '../../cmps/employee/employees-table'
import { getEmployeesByCompanyNameQuery } from '../../cmps/util-cmps/graphql-queries/employees-query'
import { Spinner } from '../../cmps/util-cmps/spinner'
import { useCachedFetch } from '../../hooks/use-cached-fetch'

export const EmployeesPage: React.FC = () => {
    const companyName = useSelector((stateModule: RootState) => stateModule.companyName.value)

    const { data, isLoading, hasError } = useCachedFetch(
        companyName ? `employees:${companyName}` : null,
        async () => {
            const query = getEmployeesByCompanyNameQuery(companyName)
            const result = await httpService.graphql(companyName, query)
            return (result.employeesByCompanyName || []) as any[]
        }
    )

    if (!companyName) {
        return <div className="tablePageContainer"><SelectCompanyPrompt /></div>
    }

    return <div className="tablePageContainer">
        <p className="tableSubtitle">Manage users for the selected company.</p>
        {isLoading && <Spinner />}
        {!isLoading && !hasError && <EmployeeTable data={data || []} />}
        {!isLoading && hasError && <div className="error-hint">Failed to load data. Try refreshing the page or re-logging in.</div>}
    </div>
}
